import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";
import { useAnalytics } from "@/hooks/useAnalytics";

interface JoinNetworkModalProps {
  isOpen: boolean;
  onClose: () => void;
  onCreateProfile: () => void;
  onBrowseFirst: () => void;
}

export const JoinNetworkModal = ({ 
  isOpen, 
  onClose, 
  onCreateProfile, 
  onBrowseFirst 
}: JoinNetworkModalProps) => {
  const { logAction } = useAnalytics();

  const handleDismiss = () => {
    logAction('join_modal_dismiss' as any);
    onClose();
  };

  const handleCreateProfile = () => {
    logAction('join_modal_cta_click' as any, { cta: 'create_profile' });
    onCreateProfile();
  };

  const handleBrowseFirst = () => {
    logAction('join_modal_cta_click' as any, { cta: 'browse_first' });
    onBrowseFirst();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleDismiss}>
      <DialogContent className="sm:max-w-md bg-white border-0 shadow-2xl">
        <DialogHeader className="relative">
          <Button
            variant="ghost"
            size="icon"
            className="absolute -top-2 -right-2 h-8 w-8 rounded-full hover:bg-gray-100"
            onClick={handleDismiss}
          >
            <X className="h-4 w-4" />
          </Button>
          <DialogTitle className="text-xl font-bold text-gray-900 text-center mb-4">
            Join the Farmer Network
          </DialogTitle>
        </DialogHeader>
        
        <div className="space-y-6">
          <p className="text-gray-700 text-center leading-relaxed">
            Create your profile to connect with other farmers, share resources, and help lobby for more funding in your region.
          </p>
          
          <div className="space-y-3">
            <Button 
              onClick={handleCreateProfile}
              className="w-full bg-green-600 hover:bg-green-700 text-white font-medium py-3"
              size="lg"
            >
              Create Profile
            </Button>
            
            <Button 
              onClick={handleBrowseFirst}
              variant="outline"
              className="w-full border-gray-300 text-gray-700 hover:bg-gray-50 font-medium py-3"
              size="lg"
            >
              Browse First
            </Button>
          </div>
          
          <p className="text-xs text-gray-500 text-center leading-relaxed">
            No spam. Your profile helps us unlock more funding for verified farmer communities.
          </p>
        </div>
      </DialogContent>
    </Dialog>
  );
};